var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M4.05 18.001H.321V5.983H4.05zM2.182 4.344a2.172 2.172 0 1 1 2.162-2.182 2.18 2.18 0 0 1-2.162 2.182m15.839 13.657h-3.727v-5.85c0-1.394-.028-3.182-1.94-3.182-1.94 0-2.238 1.515-2.238 3.082v5.95H6.388V5.983h3.579v1.64h.054a3.92 3.92 0 0 1 3.531-1.941c3.775 0 4.469 2.487 4.469 5.718z"
})));
export { SvgLinkedin as ReactComponent };
export default __webpack_public_path__ + "3ff73fa125286ef0034c42868ac2de73.svg";